<template>

  <div>
    <section id="banner" class="container-fluid py-5">
      <div class="align-items-center d-flex flex-wrap justify-content-center mt-5">
        <div style="color: var(--cor-texto);">
          <div v-html="TEXTO_BANNER_LANDING_PAGE"></div>
          <button type="button" class="btn-call-to-Action" @click="$router.push('/planos')"
            alt="Confira nosso planos">Mais
            vantagens por apenas R$9,90/mês</button>
        </div>
        <div><img :src="IMAGEM_LANDING_PAGE_01" /></div>
      </div>
    </section>

    <section class="container-fluid py-5 px-lg-5" style="background-color: var(--cor-secundaria);">
      <div class="row">
        <div class="col">
          <h3 class="titulo font-weight-bold">GAME CARDS</h3>
          <p>
            Compre aqui os gift cards dos seus jogos favoritos.
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div id="carousel" class="col m-3">
          <VueSlickCarousel v-bind="configSlider">
            <div v-for="(item, index) of logoGames" :key="index">
              <img :src="item" width="50%" alt="">
            </div>
          </VueSlickCarousel>
        </div>
        <div class="mt-4">
          <p>
            O <strong> gift card </strong>permite que você use o valor em lojas online, plataformas de streaming,
            serviços de aplicativos,
            jogos ou outros. São diversos valores para você usar ou presentear alguém.
          </p>
        </div>
      </div>

      <div class="row text-center  mt-4">
        <div class="col">
          <button type="button" style="width:30%" class="btn btn-call-to-Action" @click="$router.push('/landing')">
            Compre agora
          </button>
        </div>
      </div>
    </section>

    <section class="container-fluid py-5 px-lg-5" style="background-color:#f2f2f2">
      <div class="row">
        <div class="col">
          <h3 class="titulo font-weight-bold">CLUBE DE DESCONTOS</h3>
          <p>
            Cupons, descontos, ofertas e cashback exclusivos para assinantes Premium da SMPay.
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div id="carousel" class="col m-3">
          <VueSlickCarousel v-bind="configSlider">
            <div v-for="(item, index) of descontoMarcas" :key="index">
              <img :src="item" width="50%" alt="">
            </div>
          </VueSlickCarousel>
        </div>
        <div class="mt-4">
          <p>
            Uma seleção de lojas com as melhores ofertas do dia pra você. Compre o que você precisa com descontos e
            ofertas exclusivas que só a SMPay pode oferecer.
          </p>
        </div>
      </div>

      <div class="row text-center  mt-4">
        <div class="col">
          <button type="button" style="width:30%" class="btn btn-call-to-Action"
            @click="$router.push('/servico/clube-desconto')">
            Confira nossos descontos.
          </button>
        </div>
      </div>
    </section>

    <section class="container-fluid py-5 px-lg-5" style="background-color:var(--cor-secundaria);">
      <div class="row">
        <div class="col">
          <h3 class="titulo font-weight-bold">SERVICES CARDS</h3>
          <p>
            Gift cards dos serviços que você mais usa e gosta.
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div id="carousel" class="col-12 m-3">
          <VueSlickCarousel v-bind="configSlider">
            <div v-for="(item, index) of logoServicos" :key="index">
              <img :src="item" width="50%" alt="">
            </div>
          </VueSlickCarousel>
        </div>
        <div class="mt-4">
          <p>
            Com a SMPay você adquire gift cards para assinar serviços de streaming, taxi, trabalho e muito mais.
          </p>
        </div>
      </div>

      <div class="row text-center  mt-4">
        <div class="col">
          <button type="button" style="width:30%" class="btn btn-call-to-Action" @click="$router.push('/login')">
            Abra sua conta
          </button>
        </div>
      </div>
    </section>

    <section class="container-fluid py-5 px-lg-5" style="background-color: #f2f2f2;">
      <div class="row">
        <div class="col">
          <h3 class="titulo font-weight-bold">RECARGA DE CELULAR</h3>
          <p>
            Com a SMPay é fácil.
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div id="carousel" class="col m-3">
          <VueSlickCarousel v-bind="configSlider">
            <div v-for="(item, index) of logoOperadoras" :key="index">
              <img :src="item" width="50%" alt="">
            </div>
          </VueSlickCarousel>
        </div>
        <div class="mt-4">
          <p>
            Com a carteira digital você também pode comprar recarga de celular das principais telefonias do Brasil. É
            fácil e rápido.
          </p>
        </div>
      </div>

      <div class="row text-center  mt-4">
        <div class="col">
          <button type="button" style="width:30%" class="btn btn-call-to-Action" @click="$router.push('/login')">
            Abra sua conta
          </button>
        </div>
      </div>
    </section>

    <section class="container-fluid py-5 px-lg-5" style="background-color:var(--cor-secundaria);">
      <div class="row">
        <div class="col">
          <h3 class="titulo font-weight-bold">A SMPLAY</h3>
          <p>
            A experiência e a emoção dos torneios profissionais para todos os jogadores.
          </p>
        </div>
      </div>
      <div class="row mt-4 ">
        <div id="carousel" class="col-2 text-center">
          <img :src="IMAGEM_LANDING_PAGE_02" width="60%" alt="">
        </div>
        <div class="col">
          <p>
            O SMPlay é uma plataforma de games & eSports que leva a experiência e a emoção dos torneios profissionais
            para jogadores amadores de qualquer idade, gênero ou classe social.
          </p>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
export default {
  name: "Landing",
  components: { VueSlickCarousel },
  data() {
    return {
      pagina: window.PAGINA,
      LOGO_TOPO: window.LOGO_TOPO,
      IMAGEM_LANDING_PAGE_01: window.IMAGEM_LANDING_PAGE_01,
      IMAGEM_LANDING_PAGE_02: window.IMAGEM_LANDING_PAGE_02,
      TEXTO_BANNER_LANDING_PAGE: window.TEXTO_BANNER_LANDING_PAGE,
      configSlider: {
        dots: true,
        infinite: true,
        centerMode: true,
        centerPadding: "50px",
        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnDotsHover: true,
        pauseOnFocus: true,
        pauseOnHover: true
      },
      descontoMarcas: [
        require("@/assets/images/landing-page/desconto_amazon.jpg"),
        require("@/assets/images/landing-page/desconto_casas_bahia.jpg"),
        require("@/assets/images/landing-page/desconto_chinamaster.jpg"),
        require("@/assets/images/landing-page/desconto_dominos.jpg"),
        require("@/assets/images/landing-page/desconto_electrolux.jpg"),
        require("@/assets/images/landing-page/desconto_extra.jpg"),
        require("@/assets/images/landing-page/desconto_leroy.jpg"),
        require("@/assets/images/landing-page/desconto_magalu.jpg"),
        require("@/assets/images/landing-page/desconto_movida.jpg"),
        require("@/assets/images/landing-page/desconto_natura.jpg"),
        require("@/assets/images/landing-page/desconto_ponto.png")
      ],

      logoGames: [
        require("@/assets/images/landing-page/2.png"),
        require("@/assets/images/landing-page/3.png"),
        require("@/assets/images/landing-page/1.png"),
        require("@/assets/images/landing-page/4.png"),
        require("@/assets/images/landing-page/5.png")
      ],
      logoOperadoras: [
        require("@/assets/images/landing-page/claro.png"),
        require("@/assets/images/landing-page/vivo.png"),
        require("@/assets/images/landing-page/oi.png"),
        require("@/assets/images/landing-page/tim.png"),
        require("@/assets/images/landing-page/algar.png"),
        require("@/assets/images/landing-page/nextel.png"),
        require("@/assets/images/landing-page/brisanet.png"),
        require("@/assets/images/landing-page/sercomtel.png"),
      ],
      logoServicos: [
        require("@/assets/images/landing-page/uber.png"),
        require("@/assets/images/landing-page/netflix.png"),
        require("@/assets/images/landing-page/googleplay.png"),
        require("@/assets/images/landing-page/office365.png")
      ]
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.$store.dispatch("toogleFooter", 1);
    this.$store.dispatch("toogleMicroApp", 1);
  }, methods: {

  },
};
</script>
<style scoped lang="scss">
* {
  font-family: "Montserrat", sans-serif;
}


nav {
  background-color: #fff;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: relative;
}

section img {
  border-radius: 30px;
}

// a {
//   color: #573b1b !important;
// }

.container-landing-page {
  margin-top: 5%;
}

.saiba_mais {
  text-decoration: none !important;
}

.saiba_mais span:hover {
  border-bottom: 1px solid #573b1b;
}

.saiba_mais strong {
  font-size: 1.3rem;
}

.pagina_texto {
  color: #573b1b;
}

.t-decoration {
  text-decoration: none !important;
}

#banner {
  background-color: var(--cor-principal);
  color: var(--cor-texto);
  height: 580px;
}

#banner img {
  max-width: 400px;
  width: 15vw;
  margin: -26px 40px -40px;
}

.titulo {
  color: var(--cor-principal);
}

.btn-call-to-Action {
  background-color: var(--cor-secundaria2);
  color: var(--cor-texto);
  border-radius: 25px;
  border: 0px;
  font-weight: 550;
  font-size: 24px;
  padding: 15px;
  max-width: 70%px;
  width: 70%;
  margin-top: 5%;

}


#baixar_app {
  background-color: #fff;
  color: var(--cor-secundaria);
}

#copyright {
  background-color: #d0ae38;
  color: #fff;
}

#beneficios>div {
  margin: 0 16px;
}

#beneficios .card {
  flex: 1;
  margin: 16px;
  min-width: 270px;
  max-width: 400px;
  border-radius: 30px !important;
  overflow: hidden;
}

#carousel .card {
  border-radius: 25px !important;
  overflow: hidden;
}

#advertising .card {
  border-radius: 25px !important;
  overflow: hidden;
  background-color: transparent;
  height: 100%;
}

#advertising .card-body {
  background-color: lightgray;
  padding: 0.7rem;
}

#advertising .card-title {
  text-align: center;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 600;
}

#advertising .card-text {
  text-align: center;
  margin-bottom: 0;
  font-size: 0.8rem;
}

#advertising a {
  background-color: var(--cor-secundaria);
  border-color: var(--cor-secundaria);
}

.footer {
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
}

.footer a {
  background-color: var(--cor-secundaria2);
  border-color: var(--cor-secundaria2);
}

.loader-content {
  margin: auto;
  height: 250px;
  width: 300px;
  align-content: center;
  display: flex;
  align-items: center;
}

.loader {
  align-content: center;
  border: 16px solid #f3f3f3;
  border-top: 16px solid var(--cor-secundaria);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.hide-loader {
  display: none;
}

.logo img {
  height: 45px;
}

.style-cookies .swal2-content {
  padding: 0;
}

.style-cookies .swal2-html-container {
  text-align: left;
}

.style-cookies .swal2-confirm {
  display: inline-block;
  border-radius: 25px !important;
  background-color: #2d519d !important;
  padding: 0.625em 3em;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.slick-slide {
  margin: 0px 20px;
}

@media (max-width: 900px) {
  #banner img {
    margin: 10px 40px -40px;
  }
}
</style>
